// "I read in" (UI-C2, D-06). M1: the same 30 as "I speak" with Chinese split by script into zh-Hans
// (the default for Chinese) and zh-Hant. A separate file on purpose: this list becomes open-ended in M2.
import { SPEAK_LANGUAGES, type Language } from "./speakLanguages";

const CHINESE: readonly Language[] = [
  { tag: "zh-Hans", en: "Chinese (Simplified)", ar: "الصينية (المبسطة)", native: "简体中文" },
  { tag: "zh-Hant", en: "Chinese (Traditional)", ar: "الصينية (التقليدية)", native: "繁體中文" },
];

export const READ_LANGUAGES: readonly Language[] = SPEAK_LANGUAGES.flatMap((l) =>
  l.tag === "zh" ? CHINESE : [l],
);

export const DEFAULT_CHINESE_READING = "zh-Hans";
